import './index.scss';
import defaultProfilePicture from '../../../assets/icons/default-profile-picture.svg';
import newGameAddIcon from '../../../assets/icons/new-game-add-icon.svg';
import navigationHomeButton from '../../../assets/icons/navigation-home-button.svg';
import navigationButton2 from '../../../assets/icons/navigation-button-2.svg';
import navigationButton3 from '../../../assets/icons/navigation-button-3.svg';
import navigationButton4 from '../../../assets/icons/navigation-button-4.svg';
import { AttributesPopup, NewGamePopup } from '../../../components/Popup';
import { useState } from 'react';
import { IGameInfo } from '../../../interfaces/game-info';
import { useAppSelector } from '../../../hooks/redux';
import { PreviewPanel } from '../../../components/PreviewPanel';
import { SentForApprovalPanel } from '../../../components/SentForApprovalPanel';
import { AnimatePresence } from 'framer-motion';
import { IUserInfoState } from '../../../interfaces/slices';
import { DraftsPanel } from '../../../components/DraftsPanel';
import { PublishedGamesPanel } from '../../../components/PublishedGamesPanel';
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Image } from '../../../components/Image';

export const LandingPage3 = () => {
    const userInfo: IUserInfoState = useAppSelector((state) => state.userInfo);
    const [newGamePopupVisibility, setNewGamePopupVisibility] = useState<{ isVisible: boolean, isUpdate: boolean, gameInfo: IGameInfo | null }>({ isVisible: false, isUpdate: false, gameInfo: null });
    const [attributesPopupVisibility, setAttributesPopupVisibility] = useState<boolean>(false);
    const [selectedPublishedGame, setSelectedPublishedGame] = useState<string | null>(null);

    const getRole = (): string => {
        let role = '';

        if (userInfo.roles.maker === true) {
            role = `${role} - Maker`;
        }

        if (userInfo.roles.checker === true) {
            role = `${role} - Checker`;
        }

        if (userInfo.roles.previewer === true) {
            role = `${role} - Previewer`;
        }

        role = role.slice(3)

        return role;
    }

    const onNewGameClosePopup = (): void => {
        setNewGamePopupVisibility({ isVisible: false, isUpdate: false, gameInfo: null })
    }

    return <div className='landing-page-3-main-div'>
        <div className='landing-page-3-main-container'>
            <div className='landing-page-row-1-container'>
                <div className='profile-information-container'>
                    <Image
                        alt=''
                        src={userInfo.profilePicture}
                        fallbackSrc={defaultProfilePicture}
                        srcClassName={''}
                        fallbackClassName={''}
                        loadingIndicatorColor={'#9CB560'}
                    />
                    {/* <img src={userInfo.profilePicture != null && userInfo.profilePicture !== '' ? userInfo.profilePicture : defaultProfilePicture} alt='' /> */}
                    <div className='user-information-container'>
                        <span className='user-name-text'>{`${userInfo.firstName} ${userInfo.lastName}`}</span>
                        <span className='user-type-text'>{getRole()}</span>
                    </div>
                </div>
                <div className='search-container'></div>
                <div className='navigation-container'>
                    {/* <div className='navigation-button'>
                        <img src={navigationHomeButton} alt='' />
                    </div> */}
                    {userInfo.roles.maker === true &&
                        <Tooltip anchorElement="target" className='tooltip-custom'>
                            <div className='navigation-button'>
                                <img src={navigationButton2} alt='' title='Attributes' onClick={() => setAttributesPopupVisibility(true)} />
                            </div>
                        </Tooltip>
                    }
                    {/* <div className='navigation-button'>
                        <img src={navigationButton3} alt='' />
                    </div>
                    <div className='navigation-button'>
                        <img src={navigationButton4} alt='' />
                    </div> */}
                    {userInfo.roles.maker === true &&
                        <div className='new-game-button-container' onClick={() => setNewGamePopupVisibility({ isVisible: true, isUpdate: false, gameInfo: null })}>
                            <img src={newGameAddIcon} alt='' />
                            <span>New Game</span>
                        </div>
                    }
                </div>
            </div>
            <div className='landing-page-row-2-container'>
                <div className='game-list-container'>
                    <PublishedGamesPanel
                        setSelectedGameName={(gameName: string) => setSelectedPublishedGame(gameName)}
                    />
                </div>
                <div className='preview-list-container'>
                    <PreviewPanel
                        selectedGameName={selectedPublishedGame}
                    />
                </div>
                <div className='maker-checker-container'>
                    <div className={`approval-container ${userInfo.roles.maker === false ? `full-height` : ``}`}>
                        <SentForApprovalPanel
                        />
                    </div>
                    {userInfo.roles.maker === true &&
                        <div className='drafts-container'>
                            <DraftsPanel
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
        <AnimatePresence>
            {newGamePopupVisibility.isVisible === true &&
                <NewGamePopup
                    isApprovalMode={false}
                    updationGameInfo={newGamePopupVisibility.gameInfo}
                    closePopup={onNewGameClosePopup}
                />
            }
            {attributesPopupVisibility === true &&
                <AttributesPopup
                    closePopup={() => setAttributesPopupVisibility(false)}
                />
            }
        </AnimatePresence>
    </div >
}